import classNames from 'classnames';
import { useEffect, useState } from 'react';

import type { TextVariant } from '@farmersdog/corgi-x';
import { Link, Text, useViewport } from '@farmersdog/corgi-x';
import { Chevron } from '@farmersdog/corgi-x/icons';

import styles from './DigestHighlightsSlice.css';

interface BreedLinks {
  url: string;
  title: string;
}

function RelatedBreedLinks({ links }: RelatedBreedsProps) {
  return (
    <ul className={classNames(styles.leftColumn, styles.ul)}>
      {links.map(({ title, url }, i) => {
        return (
          <li className={styles.breedItem} key={`related-breed-${i}`}>
            <Link to={url} className={styles.breedLink} baseColor="kale">
              <Text as="span" variant="article-16">
                {title}
              </Text>
              <Chevron baseColor="Carrot2" size={24} />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

interface RelatedBreedsProps {
  links: BreedLinks[];
}

export function RelatedBreeds({ links }: RelatedBreedsProps) {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(false);
  }, []);

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;

  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-40'
    : 'heading-28';

  return (
    <>
      <Text
        className={classNames(styles.relatedHeading, styles.fullWidth)}
        as="h2"
        weight="bold"
        variant={titleVariant}
        color="kale-3"
      >
        Related breeds
      </Text>
      <RelatedBreedLinks links={links} />
    </>
  );
}
